import ProfilePopup from './ProfilePopup';

export default ProfilePopup;
